import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { GeniePadElementsSettingItem } from '../../../api/pushGenie';
import { PrintConfig, Translate } from '../../../api/pushVisit';
import PrescriptionPDFPreview from '../../../pages/PrescriptionPDFPreview';

import {
    getItemFromMisc,
    getMe,
    getTemplates,
    getTemplateV2,
    getVisitById,
    MISC_KEYS,
} from '../../../store/idbHandler';
import { Prescription } from '../../../store/types/prescription';
import {
    RenderPdfPrescription,
    TemplateConfig,
    TemplateV2,
} from '../../../Templar/RenderPdfPrescription';
import { pushVisitWithSanitizePrescription } from './finishScreen/FinishedPanel';
import { SectionNameConfig } from '../../../store/db';
import RxTemplatePdfView, {
    RX_RENDER_PDF,
} from '../../../pages/editTemplate/common/RxTemplatePdfView';
import moment from 'moment';
import { DocProfileResponse } from '../../../api/fetchDoctorProfile';
import { setTemplateFieldIfEmpty } from '../../../pages/editTemplate/common/utils';
import { randomString } from '../../../store/utils';
import { NO_FOOTER, NO_HEADER } from '../../../pages/editTemplate/EditTemplate';
import { BizSettings } from '../../../api/fetchMyGenie';
import { getDefiniteMActiveId } from '../../../store/localstorage';
import { track } from '../../../tracking';
import { AntTooltip } from '../../common/AntTooltip';
import { Button } from 'antd';
import { resetIcon } from '../../common/Icons';

type Props = {
    elemId?: string;
    prescription: Prescription;
    printConfig: PrintConfig;
    setPrintUrl?: (url: string) => void;
    translate: Translate;
    onDummyIframeLoad?: () => void;
    medElements?: GeniePadElementsSettingItem[];
    padElementsConfig?: GeniePadElementsSettingItem[];
    sectionNameConfig?: SectionNameConfig;
    force?: boolean;
    onAlreadySavedError?: () => void;
    enableFixPdfIcon?: boolean; // Optional prop to control the fix PDF icon visibility
};

export type ResData = {
    data: RenderPdfPrescription;
    config: TemplateV2;
};

const mapDoctorToDocProfileResponse = (doctor: any): DocProfileResponse | undefined => {
    if (!doctor) return undefined;

    if (doctor._id) return doctor;

    return {
        _id: doctor.id,
        profile: doctor.profile,
        created_at: doctor.created_at,
        updated_at: doctor.updated_at,
        loginmeta: doctor.loginmeta,
    };
};

type State = {
    pushStatus: 'loading' | 'success' | 'error';
    data?: ResData;
    activeClinic?: string | undefined;
    rxConfig?: TemplateConfig;
    rxLocalConfig?: TemplateConfig;
    doctorProfile?: DocProfileResponse;
    fixPdfIconEnabled?: boolean;
    footerMargin?: number;
};

class CreateLocalPrintPdf extends PureComponent<Props, State> {
    state: State = {
        pushStatus: 'loading',
        fixPdfIconEnabled: false,
    };

    componentDidMount() {
        this.generatePreview();
        if (this.props.enableFixPdfIcon) {
            getItemFromMisc<BizSettings>(getDefiniteMActiveId(), MISC_KEYS.bizSettings).then(
                (settings) => {
                    this.setState({ fixPdfIconEnabled: settings?.fixPdfIconEnabled });
                    // this.setState({ fixPdfIconEnabled: true });
                },
            );
        }
    }

    componentDidUpdate = (prevProps: Props) => {
        if (
            JSON.stringify(this.props.printConfig) !== JSON.stringify(prevProps.printConfig) ||
            JSON.stringify(this.props.translate) !== JSON.stringify(prevProps.translate) ||
            (this.props.force !== prevProps.force && this.props.force)
        ) {
            this.generatePreview();
        }
    };
    generatePreview = (): void => {
        const { prescription, printConfig: printCofig, translate } = this.props;
        getVisitById(prescription.visitId).then(async (v) => {
            if (!v) {
                return;
            }

            const templates = getTemplates();
            const templateConfig = await getTemplateV2(
                prescription.doctor._id,
                prescription.clinic._id,
                'PRINT',
            );
            const template_v2 = {
                render_pdf_config: {
                    ...templateConfig,
                    footer_height: this.state.footerMargin
                        ? (templateConfig?.footer_height?.trim()
                              ? parseFloat(templateConfig.footer_height) +
                                (this.state.footerMargin || 0)
                              : 6 + (this.state.footerMargin || 0)) + 'cm'
                        : templateConfig?.footer_height,
                    footer_top_margin: this.state.footerMargin
                        ? (templateConfig?.footer_top_margin?.trim()
                              ? parseFloat(templateConfig.footer_top_margin) +
                                (this.state.footerMargin || 0)
                              : this.state.footerMargin || 0) + 'cm'
                        : templateConfig?.footer_top_margin,
                },
                render_pdf_body_config: {
                    medication_config:
                        this.props.medElements ||
                        this.state.data?.config?.render_pdf_body_config?.medication_config,
                    pad_elements_config:
                        this.props.padElementsConfig ||
                        this.state.data?.config?.render_pdf_body_config?.pad_elements_config,
                    section_name_config:
                        this.props.sectionNameConfig ||
                        this.state.data?.config?.render_pdf_body_config?.section_name_config,
                },
            } as TemplateV2;
            pushVisitWithSanitizePrescription(
                prescription,
                v.startedAt || new Date(),
                v.endedAt || new Date(),
                'print',
                printCofig,
                translate,
                templates?.print?.templateId,
                template_v2,
                undefined,
                false, //force
                undefined, //monetisation_type
                false, //ignoredraft
                '', //draftid
                true, //isfromcreatelocalpdf
            )
                .then(async (response) => {
                    this.setState({});
                    const doctorProfile = mapDoctorToDocProfileResponse(
                        response?.data?.data?.doctor,
                    );
                    // const currentActiveClinicId =
                    //     doctorProfile?.profile?.professional?.default_clinic ||
                    //     doctorProfile?.profile?.professional?.clinics?.[0]?._id;
                    const currentActiveClinicId = prescription.clinic._id;
                    const doctorTemplateData = doctorProfile?.profile?.professional?.templates_v2;
                    const templateData = doctorTemplateData?.find(
                        (data) => data.clinicId === currentActiveClinicId && data.type === 'PRINT',
                    );

                    this.setState({
                        activeClinic: prescription?.clinic._id,
                        pushStatus: response.status === 'success' ? 'success' : 'error',
                        data: response?.data,
                        doctorProfile: doctorProfile,

                        rxConfig: setTemplateFieldIfEmpty(
                            templateData
                                ? {
                                      ...templateData,
                                      header_img:
                                          templateData.header_img &&
                                          templateData.header_img != NO_HEADER
                                              ? `${templateData.header_img}?cacheoff=${randomString(
                                                    4,
                                                )}`
                                              : templateData.header_img,
                                      footer_img:
                                          templateData.footer_img &&
                                          templateData.footer_img != NO_FOOTER
                                              ? `${templateData.footer_img}?cacheoff=${randomString(
                                                    4,
                                                )}`
                                              : templateData.footer_img,
                                      attachment_image: templateData.attachment_image
                                          ? `${
                                                templateData.attachment_image
                                            }?cacheoff=${randomString(4)}`
                                          : templateData.attachment_image,
                                  }
                                : templateData,
                        ),
                    });
                })
                .catch((e) => {
                    console.error('preview pushData=>', e);
                    this.setState({
                        pushStatus: 'error',
                    });
                });
        });
    };

    regeneratePreview = (): void => {
        track('prescription-pdf-regenerate-preview', {
            footerMargin: this.state.footerMargin?.toString(),
        });
        this.setState(
            { footerMargin: this.state.footerMargin ? this.state.footerMargin + 2 : 2 },
            () => {
                this.generatePreview();
            },
        );
    };

    resetPreview = () => {
        track('prescription-pdf-reset-preview');

        this.setState({ footerMargin: 0 }, () => {
            this.generatePreview();
        });
    };

    saveRxConfigInState = () => {
        //NA
    };
    render() {
        const { pushStatus, fixPdfIconEnabled } = this.state;

        const { prescription } = this.props;

        if (pushStatus === 'loading') {
            return (
                <div
                    style={{ width: '100%', height: '100%' }}
                    className="flex flex-col items-center justify-center space-y-64"
                >
                    <div className="pulse">
                        <svg width="16px" height="12px">
                            <polyline id="back" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
                            <polyline id="front" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
                        </svg>
                    </div>
                </div>
            );
        }
        return this.state.data && this.state.doctorProfile ? (
            <>
                <div className="h-full" id={RX_RENDER_PDF}></div>
                {fixPdfIconEnabled && (
                    <div className="absolute top-0 right-0 z-10 m-16 flex flex-col items-center justify-center space-y-8">
                        <AntTooltip content={'Add spacing to fix footer overlap'}>
                            <Button
                                onClick={this.regeneratePreview}
                                className="cursor-pointer mx-4 p-8"
                            >
                                <svg
                                    className="w-16 h-16 fill-darwin-accent-bright-blue-800"
                                    viewBox="0 0 13 13"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M8.06445 2.97266L9.4707 3.53516L10.0332 4.94141C10.0801 5.01172 10.1504 5.03516 10.2207 5.03516C10.291 5.03516 10.3379 5.01172 10.3848 4.94141L10.9707 3.53516L12.3535 2.97266C12.4238 2.92578 12.4707 2.85547 12.4707 2.78516C12.4707 2.71484 12.4238 2.66797 12.3535 2.62109L10.9707 2.03516L10.3848 0.652344C10.3379 0.582031 10.291 0.535156 10.2207 0.535156C10.1504 0.535156 10.0801 0.582031 10.0332 0.652344L9.4707 2.03516L8.06445 2.62109C7.99414 2.66797 7.9707 2.71484 7.9707 2.78516C7.9707 2.85547 7.99414 2.92578 8.06445 2.97266ZM12.3535 10.1211L10.9707 9.53516L10.3848 8.15234C10.3379 8.08203 10.291 8.03516 10.2207 8.03516C10.1504 8.03516 10.0801 8.08203 10.0332 8.15234L9.4707 9.53516L8.06445 10.1211C7.99414 10.168 7.9707 10.2148 7.9707 10.2852C7.9707 10.3555 7.99414 10.4258 8.06445 10.4727L9.4707 11.0352L10.0332 12.4414C10.0801 12.5117 10.1504 12.5352 10.2207 12.5352C10.291 12.5352 10.3379 12.5117 10.3848 12.4414L10.9707 11.0352L12.3535 10.4727C12.4238 10.4258 12.4707 10.3555 12.4707 10.2852C12.4707 10.2148 12.4238 10.168 12.3535 10.1211ZM9.4707 6.53516C9.4707 6.39453 9.37695 6.25391 9.25977 6.20703L6.61133 4.87109L5.29883 2.24609C5.1582 1.98828 4.75977 1.98828 4.61914 2.24609L3.30664 4.87109L0.658203 6.20703C0.541016 6.25391 0.470703 6.39453 0.470703 6.53516C0.470703 6.67578 0.541016 6.81641 0.658203 6.86328L3.30664 8.19922L4.61914 10.8477C4.68945 10.9648 4.80664 11.0352 4.9707 11.0352C5.08789 11.0352 5.22852 10.9648 5.29883 10.8477L6.61133 8.19922L9.25977 6.86328C9.37695 6.81641 9.4707 6.67578 9.4707 6.53516Z" />
                                </svg>
                            </Button>
                        </AntTooltip>
                        <AntTooltip content={'Reset'}>
                            <Button onClick={this.resetPreview} className="cursor-pointer mx-4 p-8">
                                {resetIcon('w-16 h-16 fill-darwin-red-primary')}
                            </Button>
                        </AntTooltip>
                    </div>
                )}
                <RxTemplatePdfView
                    data={{
                        ...this.state.data?.data,
                        date: moment().toISOString(),
                        actor: {
                            name: getMe()?.user.fn || '-',
                            id: getMe()?.user.oid || '-',
                        },
                    }}
                    rxConfig={{
                        render_pdf_config: this.state.rxConfig
                            ? {
                                  ...this.state.rxConfig,
                                  docid: this.props.prescription.doctor._id,
                                  clinicId: this.state.activeClinic || '',
                                  type: 'PRINT',
                                  footer_height: this.state.footerMargin
                                      ? (this.state.rxConfig?.footer_height?.trim()
                                            ? parseFloat(this.state.rxConfig?.footer_height) +
                                              (this.state.footerMargin || 0)
                                            : 6 + (this.state.footerMargin || 0)) + 'cm'
                                      : this.state.rxConfig?.footer_height,
                                  footer_top_margin: this.state.footerMargin
                                      ? (this.state.rxConfig?.footer_top_margin?.trim()
                                            ? parseFloat(this.state.rxConfig?.footer_top_margin) +
                                              (this.state.footerMargin || 0)
                                            : this.state.footerMargin || 0) + 'cm'
                                      : this.state.rxConfig?.footer_top_margin,
                              }
                            : undefined,
                        render_pdf_body_config: {
                            medication_config:
                                this.props.medElements ||
                                this.state.data?.config?.render_pdf_body_config?.medication_config,
                            pad_elements_config:
                                this.props.padElementsConfig ||
                                this.state.data?.config?.render_pdf_body_config
                                    ?.pad_elements_config,
                            section_name_config:
                                this.props.sectionNameConfig ||
                                this.state.data?.config?.render_pdf_body_config
                                    ?.section_name_config,
                        },
                    }}
                    // rxLocalConfig={rxLocalConfig}
                    activeClinic={this.state.activeClinic}
                    saveRxConfigInState={this.saveRxConfigInState}
                    docProfile={this.state.doctorProfile}
                    locallyCreatedPdf={true}
                />
            </>
        ) : (
            <PrescriptionPDFPreview id={prescription.id} />
        );
    }
}

export default connect()(CreateLocalPrintPdf);
